import { Component, Input, OnInit, Output, EventEmitter, SimpleChange } from '@angular/core';
import { ProductApiFieldFilter } from '@app/models/ProductAPI/product-api-field-filter.model';
import { ProductApiGridFilter } from '@app/models/product-api-management/product-api-grid-filter.model';
import { ProductApiGrid } from '@app/models/product-api-management/product-api-grid.model';
import { ProductApi } from '@app/models/product-api-management/product-api.model';
import { Subject } from 'rxjs';
import { Product } from '../drawing-helper/model/draggable-device';
import { ProductApiManagementService } from '@app/services/productApiManagement/product-api-management.service';
import { ProductApiFilter } from '@app/models/product-api-management/product-api-filter.model';
import { ProductApiGridColumn } from '@app/models/product-api-management/product-api-grid-column.model';
import { ProductApiGridCell } from '@app/models/product-api-management/product-api-grid-cell.model';
import { ProductApiGridRow } from '@app/models/product-api-management/product-api-grid-row.model';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: "app-product-api-grid",
  templateUrl: "./product-api-grid.component.html",
  styleUrls: ["./product-api-grid.component.scss"],
})
export class ProductApiGridComponent implements OnInit {
  @Input() selectedApi: ProductApi;
  @Input() disciplineName: string;
  @Input() deviceTypeId : number;

  @Output()
  public productApiGridUpdated: EventEmitter<ProductApiGrid> = new EventEmitter<ProductApiGrid>();

  @Output()
  public productApiProductChecked: EventEmitter<ProductApiGridRow> = new EventEmitter<ProductApiGridRow>();

  public productApiGrid: ProductApiGrid;
  public filterMap = new Map<string, ProductApiFieldFilter[]>();
  public filterColumnMap = new Map<string, string>();
  public activeColumn: ProductApiGridColumn;
  public productApiProductIdsMap = new Map<number, number>();
  public filteringInProgress: boolean = false;
  public loadingInProgress: boolean = false;
  private filterInputChanged: Subject<Map<ProductApiGridColumn, string>> = new Subject<
    Map<ProductApiGridColumn, string>
  >();
  private debounceTime = 1000;
  public maxSize: number = 20;
  public page: number = 1;
  public itemsPerPage: number = 10;
  public productApiGridFilter: ProductApiGridFilter;
  constructor(private productApiManagementService: ProductApiManagementService) {}

  ngOnInit() {
    this.selectedApi = null;
    this.productApiGrid = null;
    this.filterInputChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe((res) => {
        this.filteringInProgress = true;
        res.forEach((value: string, key: ProductApiGridColumn) => {
          this.triggerGridFiltering(key, value);
        });
      });
  }

  ngOnChanges(changes: SimpleChange) {
    if (changes["selectedApi"] !== undefined && this.selectedApi !== null) {
      this.productApiGridFilter = new ProductApiGridFilter();
      this.productApiGridFilter.productApiId = this.selectedApi.id;
      this.productApiGridFilter.pageSize = this.itemsPerPage;
      this.productApiGridFilter.page = this.page;
      this.productApiGridFilter.filterValues = [];
      this.loadingInProgress = true;
      this.productApiManagementService.getProductApiGrid(this.productApiGridFilter).subscribe((res)=> {
        this.productApiGrid = {...res};
        this.productApiGridFilter = {...res.filterModel};
        this.loadingInProgress = false;
      });
    } else if(this.selectedApi === null) {
      this.productApiGrid = null;
      this.productApiGridFilter = null;
    }
  }

  public onColumnFilter(event: Event, productApiGridColumn: ProductApiGridColumn) {
    let inputTarget = <HTMLInputElement>event.target;
    let filterValue = inputTarget.value;
    var inputMap = new Map<ProductApiGridColumn, string>();
    inputMap.set(productApiGridColumn, filterValue);
    this.activeColumn = productApiGridColumn;
    this.filterInputChanged.next(inputMap);
  }

  private triggerGridFiltering(productApiGridColumn: ProductApiGridColumn, filterValue: string) {
    let filterValueCheck = this.productApiGridFilter.filterValues.filter(f => f.productApiMappedFieldId === productApiGridColumn.productApiMappedFieldId);
    if(filterValueCheck.length == 0 && filterValue.length > 0) {
      this.productApiGridFilter.filterValues.push({productApiMappedFieldId: productApiGridColumn.productApiMappedFieldId, fieldName: productApiGridColumn.columnName, fieldValue: filterValue});
    } else if(filterValue.length === 0 && filterValueCheck.length > 0) {
      for(let p = 0; p < this.productApiGridFilter.filterValues.length;p++) {
        if(this.productApiGridFilter.filterValues[p].productApiMappedFieldId === productApiGridColumn.productApiMappedFieldId) {
          this.productApiGridFilter.filterValues.splice(p, 1);
        }
      }
    } else if(filterValue.length > 0 && filterValueCheck.length > 0) {
      for(let p = 0; p < this.productApiGridFilter.filterValues.length;p++) {
        if(this.productApiGridFilter.filterValues[p].productApiMappedFieldId === productApiGridColumn.productApiMappedFieldId) {
          this.productApiGridFilter.filterValues[p].fieldValue = filterValue;
        }
      }
    }
    this.productApiManagementService.getProductApiGrid(this.productApiGridFilter).subscribe((res)=> {
      this.productApiGrid = {...res};
      this.filteringInProgress = false;
    });
  }

  public getColumnFilterValue(productApiGridColumn: ProductApiGridColumn) {
    if (this.productApiGridFilter && this.productApiGridFilter.filterValues.filter(x => x.productApiMappedFieldId === productApiGridColumn.productApiMappedFieldId).length > 0) {
      return this.productApiGridFilter.filterValues.filter(x => x.productApiMappedFieldId === productApiGridColumn.productApiMappedFieldId)[0].fieldValue;
    } else {
      return "";
    }
  }

  public selectColumnToDisplay(cells: ProductApiGridCell[], columnName: string) {
    let cellToDisplay: ProductApiGridCell = new ProductApiGridCell();
    cellToDisplay.overrideDisplayValue = null;
    cellToDisplay = {...cells.filter((x) => x.columnName === columnName)[0]};
    return cellToDisplay;
  }

  public onRadioAssignProduct(product: ProductApiGridRow) {
    console.log("Logged Product");
    console.log(product);
    this.productApiProductChecked.emit(product);
  }

  onAssignProductPageChanged($event) {
    this.productApiGridFilter.page = $event.page;
    this.productApiManagementService
      .getProductApiGrid(
        this.productApiGridFilter
      )
      .subscribe((res) => {
        this.productApiGrid = res;
      });
  }
}
